module.exports = __webpack_public_path__ + "media/images/flags/1x1/ala-ad31f8f3bea9eb00f1f6d37a12b6bbc2.svg";